"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CardComparisonContainerState = /** @class */ (function () {
    function CardComparisonContainerState() {
        this.comparisonIndex = 0;
    }
    return CardComparisonContainerState;
}());
exports.default = CardComparisonContainerState;
//# sourceMappingURL=CardComparisonContainerState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/CardComparisonContainerState.js
// module id = 1306
// module chunks = 8